module.exports = __webpack_public_path__ + "img/ia-01-7.32fab16e.jpg";